import { useSelector } from 'react-redux';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import BetslipButton from 'modules/betslip-button/index.js';

const BetsTypes = MojitoServices.Bets.types;
const EventUtils = MojitoServices.SportsContent.Events.utils;
const { Text, AbsolutePane } = MojitoPresentation.Components;
const { selectors: betslipSelectors, utils: BetslipUtils } = MojitoServices.Betslip;
const { selectBetslipStatus, selectBetslip, selectHasSuspendedBet } = betslipSelectors;

const resolveLabel = bet => {
    const { legSort } = bet;
    const isBetBuilder =
        legSort === BetsTypes.LEG_SORT.BET_BUILDER || legSort === BetsTypes.LEG_SORT.MATCH_ACCA;
    if (isBetBuilder) {
        return '$FLOATING_BETSLIP_PILL.BET_BUILDER';
    }
    if (bet.isBBAcca) {
        return '$FLOATING_BETSLIP_PILL.BET_BUILDER_ACCA';
    }
};

export default function FloatingBetslipPill(props) {
    const {
        mojitoTools,
        isOpen,
        isBetslipCommitted,
        isQuickBetslip,
        enableFreebetsIndication,
        onClick,
    } = props;
    const betslip = useSelector(selectBetslip);
    const isOverask = useSelector(state => BetslipUtils.isOverask(selectBetslipStatus(state)));
    const isBetslipEmpty = BetslipUtils.isBetslipEmpty(betslip);

    const bet = BetslipUtils.getTopBetslipBet(betslip, {
        single: true,
        betBuilder: true,
        accumulator: true,
        betBuilderAcca: true,
    });

    // Hide pill when: betslip is empty AND no receipt AND not in overask
    if (isBetslipEmpty && !isBetslipCommitted && !isOverask) {
        return;
    }

    // Hide pill synchronously when QBS closes with a receipt
    if (!isOpen && isBetslipCommitted) {
        return;
    }

    const { style } = mojitoTools;
    const { container, button } = isOpen ? style.openedButtonState : style.closedButtonState;

    return (
        <div className="ta-FloatingBetslipPill" style={container.style}>
            <BetslipButton
                config={button}
                isQuickBetslip={isQuickBetslip}
                showImage={isBetslipCommitted}
                enableFreebetsIndication={enableFreebetsIndication}
                onClick={onClick}
            >
                {bet && !isOpen && <TopBetOdds mojitoTools={mojitoTools} bet={bet} />}
            </BetslipButton>
        </div>
    );
}

const TopBetOdds = props => {
    const { mojitoTools, bet } = props;
    const { stringResolver, config, l10n } = mojitoTools;

    const suspended = useSelector(selectHasSuspendedBet);

    const { odds, priceType } = bet || {};

    const label = stringResolver.resolveString(resolveLabel(bet));
    const priceText =
        odds && !suspended
            ? EventUtils.getDisplayedOdds(odds, priceType, l10n)
            : stringResolver.resolveString('$FLOATING_BETSLIP_PILL.NO_ODDS');

    return (
        <AbsolutePane config={config.oddsContainer} class="ta-TopBetOdds">
            {label && (
                <Text config={config.betTypeLabel} class="ta-TopBetOddsLabel">
                    {label}
                </Text>
            )}
            {priceText && (
                <Text config={config.oddsLabel} class="ta-TopBetOddsPrice">
                    {priceText}
                </Text>
            )}
        </AbsolutePane>
    );
};

FloatingBetslipPill.getStyle = (config, applicationMode, merge) => {
    return {
        openedButtonState: merge(config.baseBetslipButtonState, config.openedBetslipButtonState),
        closedButtonState: merge(config.baseBetslipButtonState, config.closedBetslipButtonState),
    };
};
